import { jsx } from "panel";
import isEmpty from "lodash/isEmpty";
import { Theme, TrackName } from "common/components/data-table/types";
import { EmptyDataEl } from "common/charts/misc/empty-data";
import { DataTableEl } from "common/components/data-table";
import { REPORT_LIMITS, ReportName } from "common/report/constants";
import { ContextMenuEl } from "common/widgets/context-menu";
import { isCustomCsvLimitEnabled } from "common/widgets/csv-export-modal/utils";
import { getInsightsAggregateCsvExportLimit } from "common/report/util";
export function template() {
  var _a, _b, _c, _d;
  if (isEmpty((_a = this.params.results) == null ? void 0 : _a.series)) {
    return /* @__PURE__ */ jsx("div", { sel: ".root" }, /* @__PURE__ */ jsx(EmptyDataEl, null));
  }
  if (!this.hasRequiredParams(this.params) || !this.state.rows) {
    return /* @__PURE__ */ jsx("div", { sel: ".root" });
  }
  const { rows, columnGroups, segmentMetadata, sortConfig, segmentationLimit, popoverState } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".root" }, /* @__PURE__ */ jsx(
    DataTableEl,
    {
      attrs: {
        elref: `dataTable`,
        theme: Theme.Standalone,
        "track-name": TrackName.InsightsTable,
        sorting: sortConfig,
        "segmentation-limit": segmentationLimit,
        "export-segmentation-limit": isCustomCsvLimitEnabled(this.currentProject) ? getInsightsAggregateCsvExportLimit(this.currentProject) : REPORT_LIMITS[ReportName.Insights].csvExport,
        "resizing-layout": this.params.resizingLayout,
        "start-scrolled-right": this.params.startScrolledRight,
        "is-pivot-view": true,
        "lift-comparison-type": (_b = this.params.bookmarkParams.liftComparison) == null ? void 0 : _b.type,
        "selected-cell": this.state.popoverState ? { columnIdx: (_c = this.state.popoverState) == null ? void 0 : _c.columnIndex, rowIdx: (_d = this.state.popoverState) == null ? void 0 : _d.rowIndex } : null,
        // No special column width persistence on boards yet
        ...this.params.resizingLayout ? { "column-width-overrides": this.params.columnWidthOverrides } : {}
      },
      props: {
        dataTableParams: {
          columnGroups,
          rows,
          segmentMetadata
        }
      },
      on: {
        sortChange: (ev) => this.params.sortChangeCallback(ev.detail),
        cellClick: this.params.popoverCallback ? this.handleCellClick : null,
        columnResize: (ev) => {
          var _a2, _b2;
          return (_b2 = (_a2 = this.params).columnResizeCallback) == null ? void 0 : _b2.call(_a2, ev);
        }
      }
    }
  ), this.state.isDownloadTruncated ? /* @__PURE__ */ jsx("div", { sel: ".truncated-data-download-text" }, "Results have been truncated to the first 30 results for export.") : null, popoverState && /* @__PURE__ */ jsx(
    ContextMenuEl,
    {
      attrs: {
        "menu-items": this.getPopoverMenuItems(),
        open: true
      },
      props: {
        positionParent: popoverState.virtualElementPosition
      },
      on: {
        action: (ev) => this.handlePopoverAction(ev),
        close: () => this.handlePopoverClose()
      }
    }
  ));
}
